<div class="upload-wrapper" [ngClass]="{'lg': lg, 'sm': sm}" [hidden]="!showUploader">
  <!-- Estado vazio -->
  <div class="estado-vazio" *ngIf="!listaImagens?.length && !editarImagem && qtdRestantes > 0" (click)="fileInput2.click()">
    <input #fileInput2 type="file" accept=".jpg,.jpeg,.png" [multiple]="true" (change)="onFileInputChange($event)" style="display:none">
    <i class="fas fa-camera"></i>
    <p>Clique para adicionar imagens</p>
    <span>JPG, JPEG ou PNG</span>
  </div>

  <div class="galeria-imagens" *ngIf="listaImagens?.length">
    <!-- Imagem principal (capa) -->
    <div class="imagem-card imagem-capa" *ngIf="getLinkPrimeiraImagem() && !editarImagem">
      <span class="badge-capa">Capa</span>
      <img src="/images/empresa/{{getLinkPrimeiraImagem()}}" alt="Imagem principal do produto">
      <button type="button" class="btn-zoom" (click)="abrirZoom(0)" title="Ampliar imagem">
        <i class="fas fa-search-plus"></i>
      </button>
      <button type="button" class="btn-remover" (click)="removerFoto(0)" title="Remover imagem">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>

    <!-- Imagens adicionais -->
    <ng-container *ngIf="possuiMaisDeUmaImagem()">
      <ng-container *ngFor="let imagem of listaImagens; let i = index">
        <div class="imagem-card" *ngIf="i > 0">
          <img src="/images/empresa/{{getLinkImagem(i)}}" alt="Imagem {{i + 1}} do produto">
          <button type="button" class="btn-zoom" (click)="abrirZoom(i)" title="Ampliar imagem">
            <i class="fas fa-search-plus"></i>
          </button>
          <button type="button" class="btn-remover" (click)="removerFoto(i)" title="Remover imagem">
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </ng-container>
    </ng-container>

    <!-- Botão adicionar -->
    <div class="imagem-card card-adicionar" *ngIf="!editarImagem && qtdRestantes > 0" (click)="fileInput.click()">
      <input #fileInput type="file" accept=".jpg,.jpeg,.png" [multiple]="true" (change)="onFileInputChange($event)" style="display:none">
      <div class="adicionar-conteudo">
        <i class="fas fa-plus"></i>
        <span>Adicionar</span>
        <small class="adicionar-restantes">{{ qtdRestantes }} restantes</small>
      </div>
    </div>
  </div>


  <!-- Ações salvar -->
  <div class="acoes-salvar" *ngIf="exibirSalvar()">
    <p>Salvar alterações nas imagens?</p>
    <div class="acoes-botoes">
      <button class="btn btn-success btn-sm" (click)="salveImagem()" [disabled]="salvando">
        <i class="fe-save"></i> Confirmar
      </button>
      <button class="btn btn-light btn-sm" (click)="canceleSalvar()" [disabled]="salvando">
        <i class="fa fa-times"></i> Cancelar
      </button>
    </div>
    <span *ngIf="erroSalvar" class="text-danger mt-1 d-block"><b>{{erroSalvar}}</b></span>
  </div>
</div>

<!-- Lightbox zoom -->
<div class="lightbox-overlay" *ngIf="imagemZoom !== null" (click)="fecharZoom()">
  <div class="lightbox-content" (click)="$event.stopPropagation()"
       (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <img src="/images/empresa/{{getLinkImagem(imagemZoom)}}" alt="Imagem ampliada">
    <div class="lightbox-footer">
      <span class="lightbox-counter">{{imagemZoom + 1}} de {{listaImagens.length}}</span>
      <div class="lightbox-nav" *ngIf="listaImagens.length > 1">
        <button type="button" class="btn btn-sm btn-outline-light" (click)="imagemZoom = imagemZoom > 0 ? imagemZoom - 1 : listaImagens.length - 1" title="Anterior">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-light" (click)="imagemZoom = imagemZoom < listaImagens.length - 1 ? imagemZoom + 1 : 0" title="Próxima">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <button type="button" class="lightbox-close" (click)="fecharZoom()" title="Fechar">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<!-- Cropper Dialog -->
<kendo-dialog class="pv2-cropper-dialog" *ngIf="!showUploader" title="Recortar Imagem ({{currentImageIndex + 1}} de {{imagensCortar.length}})" [width]="650" (close)="canceleCortarImagem()">
  <div class="cropper-dialog-body">
    <div *ngFor="let image of imagensCortar; let i = index">
      <div *ngIf="currentImageIndex === i">
        <image-cropper #imageCropper
                       [imageChangedEvent]="createImageChangedEvent(image.rawFile)"
                       [maintainAspectRatio]="true"
                       [aspectRatio]="4/3"
                       [resizeToWidth]="600"
                       [cropperMinWidth]="400"
                       [onlyScaleDown]="true"
                       [roundCropper]="false"
                       [transform]="transform"
                       format="png"
                       outputType="base64"
                       (imageCropped)="imageCropped($event)"
                       (imageLoaded)="imageLoaded()"
                       (cropperReady)="cropperReady()"
                       (loadImageFailed)="loadImageFailed()"
                       [style.display]="showCropper ? null : 'none'"
                       [alignImage]="'center'"
        ></image-cropper>
      </div>
    </div>
    <span *ngIf="erroLoadImage" class="text-danger mt-2 d-block"><b>{{erroLoadImage}}</b></span>
  </div>
  <kendo-dialog-actions layout="end">
    <div class="cropper-actions">
      <div class="zoom-controls">
        <button class="btn btn-outline-secondary btn-sm" (click)="zoomOut()" title="Diminuir zoom">
          <i class="fas fa-search-minus"></i>
        </button>
        <button class="btn btn-outline-secondary btn-sm" (click)="zoomIn()" title="Aumentar zoom">
          <i class="fas fa-search-plus"></i>
        </button>
      </div>
      <div class="main-actions">
        <button class="btn btn-outline-secondary" (click)="canceleCortarImagem()" [disabled]="enviando">Cancelar</button>
        <button class="btn btn-success" (click)="confirmeCrop()" [disabled]="enviando || !isCropping">
          <i class="k-icon k-i-loading mr-1" *ngIf="enviando"></i>
          {{imagensCortar.length > currentImageIndex + 1 ? 'Próxima Imagem': 'Confirmar'}}
        </button>
      </div>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>
